module.exports = __webpack_public_path__ + "img/W_PIV.55a277eb.svg";